export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-4 sm:mb-6">
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center">
                <i className="ri-global-line text-2xl sm:text-3xl text-teal-400"></i>
              </div>
              <span className="text-xl sm:text-2xl font-bold">NOARE website</span>
            </div>
            <p className="text-sm sm:text-base text-gray-400 leading-relaxed">
              あなたのビジネスをオンラインで輝かせる、プロフェッショナルなWebサイト制作サービス
            </p>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">サービス</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('pricing')}
                  className="text-sm sm:text-base text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  料金プラン
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('initial-cost')}
                  className="text-sm sm:text-base text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  初期費用
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm sm:text-base text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">会社情報</h3>
            <ul className="space-y-2">
              <li className="text-sm sm:text-base text-gray-400">運営会社: NOARE</li>
              <li className="text-sm sm:text-base text-gray-400">営業時間: 平日 9:00-18:00</li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">お問い合わせ</h3>
            <ul className="space-y-2">
              <li className="flex items-center text-sm sm:text-base text-gray-400">
                <i className="ri-mail-line mr-2 text-teal-400"></i>
                ngszk0427@gmail.com
              </li>
              <li className="flex items-center text-sm sm:text-base text-gray-400">
                <i className="ri-phone-line mr-2 text-teal-400"></i>
                090-8079-1727
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-xs sm:text-sm text-gray-400 text-center sm:text-left">
              © 2025 NOARE website. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs sm:text-sm text-gray-400 hover:text-teal-400 transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}